import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { DealerSocialMediaFragmentFragment } from './DealerSocialMediaFragment';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { DealerSocialMediaFragmentFragmentDoc } from './DealerSocialMediaFragment';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
export type DealerContactFragmentFragment = (
  { __typename: 'DealerContact' }
  & Pick<SchemaTypes.DealerContact, 'email'>
  & { telephone?: SchemaTypes.Maybe<(
    { __typename: 'OptionalPhone' }
    & Pick<SchemaTypes.OptionalPhone, 'prefix' | 'value'>
  )>, address?: SchemaTypes.Maybe<(
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  )>, additionalInfo?: SchemaTypes.Maybe<(
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  )>, socialMedia: Array<(
    { __typename: 'DealerSocialMedia' }
    & DealerSocialMediaFragmentFragment
  )> }
);

export const DealerContactFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerContactFragment on DealerContact {
  telephone {
    prefix
    value
  }
  email
  address {
    ...TranslatedStringData
  }
  additionalInfo {
    ...TranslatedStringData
  }
  socialMedia {
    ...DealerSocialMediaFragment
  }
}
    `;